import React, { useState } from "react";
import Sidebar from "../Components/Sidebar";
import ReportsNavbar from "../Components/ReportsNavbar";
import Table from "../Components/Table";
import { S3Apis } from "../Services/ThirdPartyApi/AWS/S3";
import { Toaster } from "react-hot-toast";

const Home = () => {
  const [tableFor, setTableFor] = useState("All");
  const [reportData, setReportData] = useState([]);

  React.useEffect(() => {
    setReportData([]);

    const getImagelist = async (fileName) => {
      const response = await S3Apis.getFileList(fileName);
      setReportData(response.slice(1).reverse());
    };

    getImagelist(tableFor);
  }, [tableFor]);

  return (
    <div className="h-screen flex">
      <Sidebar tableFor={tableFor} />
      <Toaster />
      <div className="reportAndReportNavContainer flex flex-col grow">
        <ReportsNavbar setTableFor={setTableFor} />
        <Table tableFor={tableFor} tableData={reportData} />
      </div>
    </div>
  );
};

export default Home;
